import * as React from "react";
import {cx} from "emotion";

import "./radio.scss";

export const Radio = ({selected, onClick=undefined, disabled=undefined, xdQaName=undefined, size=undefined, ...props}) => (
    <div 
        className={cx("radio radio-9vf", {selected, disabled}, size && "size-" + size)}
        onClick={onClick}
        xd-qa-type="radio" 
        xd-qa-name={xdQaName}
        {...props}
    />
);